export default "__VITE_ASSET__CObTV2RJ__"